// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%23ffd700%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27m2 5 6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%23ff8a80%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27m2 5 6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contactBlock_section__82tMN h2 {
  color: #fff;
}
.contactBlock_layout__F-qZZ {
  display: grid;
  gap: var(--space-7);
  grid-template-columns: minmax(0, 1fr);
  align-items: start;
}
.contactBlock_intro__XWtOl header {
  margin-bottom: var(--space-6);
}
.contactBlock_points__csQOX {
  margin: 0 0 var(--space-6);
  padding: 0;
  list-style: none;
  display: grid;
  gap: var(--space-3);
}
.contactBlock_points__csQOX li {
  position: relative;
  padding-left: 1.75rem;
  line-height: 1.5;
}
.contactBlock_points__csQOX li::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0.65em;
  width: 0.9rem;
  height: 2px;
  background: var(--kur-gold);
}
.contactBlock_direct__S-sQs {
  margin: 0;
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-4) var(--space-7);
  padding-top: var(--space-5);
  border-top: 1px solid var(--color-border-on-dark);
}
.contactBlock_direct__S-sQs dt {
  font-size: var(--text-eyebrow);
  letter-spacing: var(--tracking-eyebrow);
  text-transform: uppercase;
  color: var(--color-text-muted-on-dark);
  margin-bottom: 0.25rem;
}
.contactBlock_direct__S-sQs dd {
  margin: 0;
  font-size: 1.15rem;
}
.contactBlock_direct__S-sQs a {
  color: #fff;
  text-decoration: none;
  border-bottom: 1px solid var(--kur-gold);
}
.contactBlock_direct__S-sQs a:hover {
  color: var(--kur-gold);
}
.contactBlock_note__xKt3Q {
  margin: var(--space-5) 0 0;
  font-size: var(--text-caption);
  line-height: 1.55;
  color: var(--color-text-muted-on-dark);
}
.contactBlock_form__b3E8E {
  min-width: 0;
  padding: clamp(1.25rem, 1rem + 2vw, 2.5rem);
  border: 1px solid var(--color-border-on-dark);
  border-radius: var(--radius-lg);
  background: rgba(255, 255, 255, 0.03);
}
.contactBlock_form__b3E8E .container {
  padding: 0;
  max-width: none;
}
/* forms written for older layouts set their own narrow width and padding */
.contactBlock_form__b3E8E form {
  max-width: none;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 1.1rem;
}
.contactBlock_form__b3E8E > div {
  padding-top: 0;
  padding-bottom: 0;
}
.contactBlock_direct__S-sQs dd {
  white-space: pre-line;
}

/* Locations map under the form. The map component sizes itself for a full
   page, so its outer box is tightened here. */
.contactBlock_map__SICFF {
  margin-top: clamp(3rem, 2rem + 3vw, 5rem);
  padding-top: clamp(2rem, 1.5rem + 2vw, 3rem);
  border-top: 1px solid var(--color-border-on-dark);
}
.contactBlock_map__SICFF > div {
  min-height: 0;
  padding: 0;
}

@media (min-width: 992px) {
  .contactBlock_layout__F-qZZ {
    grid-template-columns: minmax(0, 0.85fr) minmax(0, 1.15fr);
    gap: var(--space-8);
  }
  .contactBlock_intro__XWtOl {
    position: sticky;
    top: 9rem;
  }
}

.contactBlock_note__xKt3Q a {
  color: #fff;
  text-decoration: none;
  border-bottom: 1px solid var(--kur-gold);
}
.contactBlock_note__xKt3Q a:hover {
  color: var(--kur-gold);
}

/* ---- Form fields: one dark, themed style for every audience form ---- */
.contactBlock_form__b3E8E .form-label,
.contactBlock_form__b3E8E label {
  margin-bottom: 0.4rem;
  font-size: 0.85rem;
  font-weight: 500;
  letter-spacing: 0.01em;
  color: var(--color-text-muted-on-dark);
}
.contactBlock_form__b3E8E .form-control,
.contactBlock_form__b3E8E .form-select,
.contactBlock_form__b3E8E textarea {
  width: 100%;
  min-height: 3.1rem;
  padding: 0.8rem 1rem;
  border: 1px solid rgba(255, 255, 255, 0.14);
  border-radius: 10px;
  background-color: rgba(255, 255, 255, 0.04);
  color: #fff;
  font-family: var(--font-sans);
  font-size: 1rem;
  box-shadow: none;
  transition: border-color var(--dur-fast) ease, background-color var(--dur-fast) ease,
    box-shadow var(--dur-fast) ease;
}
.contactBlock_form__b3E8E textarea {
  min-height: 8rem;
  resize: vertical;
}
.contactBlock_form__b3E8E .form-select {
  padding-right: 2.75rem;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 1rem center;
  background-size: 14px 10px;
}
.contactBlock_form__b3E8E .form-select option {
  color: var(--color-ink);
  background: #fff;
}
.contactBlock_form__b3E8E .form-control::placeholder,
.contactBlock_form__b3E8E textarea::placeholder {
  color: rgba(255, 255, 255, 0.38);
}
.contactBlock_form__b3E8E .form-control:hover,
.contactBlock_form__b3E8E .form-select:hover,
.contactBlock_form__b3E8E textarea:hover {
  border-color: rgba(255, 255, 255, 0.3);
}
.contactBlock_form__b3E8E .form-control:focus,
.contactBlock_form__b3E8E .form-select:focus,
.contactBlock_form__b3E8E textarea:focus {
  outline: none;
  color: #fff;
  border-color: var(--kur-gold);
  background-color: rgba(255, 255, 255, 0.07);
  box-shadow: 0 0 0 3px rgba(255, 215, 0, 0.18);
}
.contactBlock_form__b3E8E .form-control.is-invalid,
.contactBlock_form__b3E8E .form-select.is-invalid {
  border-color: #ff8a80;
  background-image: none;
}
.contactBlock_form__b3E8E .form-select.is-invalid {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
.contactBlock_form__b3E8E .form-control.is-invalid:focus,
.contactBlock_form__b3E8E .form-select.is-invalid:focus {
  box-shadow: 0 0 0 3px rgba(255, 138, 128, 0.2);
}
.contactBlock_form__b3E8E .invalid-feedback {
  margin-top: 0.35rem;
  font-size: 0.8rem;
  color: #ff8a80;
}
/* keep browser autofill on the dark field */
.contactBlock_form__b3E8E .form-control:-webkit-autofill {
  -webkit-text-fill-color: #fff;
  -webkit-box-shadow: 0 0 0 100px #2a2f36 inset;
  caret-color: #fff;
}
.contactBlock_form__b3E8E .form-check-input {
  accent-color: var(--kur-gold);
  background-color: transparent;
  border-color: rgba(255, 255, 255, 0.4);
}
.contactBlock_form__b3E8E .form-check-input:checked {
  background-color: var(--kur-gold);
  border-color: var(--kur-gold);
}
.contactBlock_form__b3E8E .form-check-label {
  color: var(--color-text-muted-on-dark);
  line-height: 1.5;
}
.contactBlock_form__b3E8E button[type="submit"] {
  width: 100% !important;
  min-height: 3.25rem;
  padding: 0.85rem 2rem !important;
  border: 0 !important;
  border-radius: 999px !important;
  background: linear-gradient(180deg, #ffe23a, var(--kur-gold)) !important;
  color: var(--color-ink) !important;
  font-family: var(--font-sans);
  font-size: 1rem;
  font-weight: 600;
  letter-spacing: 0.02em;
  box-shadow: 0 10px 30px -10px rgba(255, 215, 0, 0.55), inset 0 1px 0 rgba(255, 255, 255, 0.5);
  transition: transform var(--dur-fast) ease, box-shadow var(--dur-fast) ease, filter var(--dur-fast) ease;
}
.contactBlock_form__b3E8E button[type="submit"]:hover:not(:disabled) {
  transform: translateY(-2px);
  filter: brightness(1.04);
  box-shadow: 0 16px 36px -12px rgba(255, 215, 0, 0.7), inset 0 1px 0 rgba(255, 255, 255, 0.5);
}
.contactBlock_form__b3E8E button[type="submit"]:disabled {
  opacity: 0.6;
  cursor: progress;
}
.contactBlock_form__b3E8E .form-control[type="file"] {
  padding: 0.45rem;
  line-height: 2;
  color: var(--color-text-muted-on-dark);
  cursor: pointer;
}
.contactBlock_form__b3E8E .form-control[type="file"]::file-selector-button {
  margin: 0 1rem 0 0;
  padding: 0.45rem 1rem;
  border: 1px solid rgba(255, 215, 0, 0.6);
  border-radius: 6px;
  background: rgba(255, 215, 0, 0.1);
  color: #fff;
  font-family: var(--font-sans);
  font-weight: 500;
  transition: background-color var(--dur-fast) ease;
}
.contactBlock_form__b3E8E .form-control[type="file"]:hover::file-selector-button {
  background: rgba(255, 215, 0, 0.2);
}
/* consent checkbox: left-aligned, readable, box lined up with the first line */
.contactBlock_form__b3E8E .form-check {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  margin: 0;
  padding: 1rem;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.025);
  text-align: left;
}
.contactBlock_form__b3E8E .form-check-input {
  flex: none;
  width: 1.15rem;
  height: 1.15rem;
  margin: 0.15rem 0 0;
  float: none;
}
.contactBlock_form__b3E8E .form-check-label,
.contactBlock_form__b3E8E .form-check-label * {
  font-size: 0.85rem;
  text-align: left;
}
.contactBlock_form__b3E8E .form-check .invalid-feedback {
  flex-basis: 100%;
}
.contactBlock_form__b3E8E .form-check {
  flex-wrap: wrap;
}
.contactBlock_form__b3E8E .form-check-label {
  flex: 1 1;
  min-width: 0;
}
`, "",{"version":3,"sources":["webpack://./src/COMPONENTS/CONTACT_BLOCK/contactBlock.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,qCAAqC;EACrC,kBAAkB;AACpB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,0BAA0B;EAC1B,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,WAAW;EACX,aAAa;EACb,WAAW;EACX,2BAA2B;AAC7B;AACA;EACE,SAAS;EACT,aAAa;EACb,eAAe;EACf,kCAAkC;EAClC,2BAA2B;EAC3B,iDAAiD;AACnD;AACA;EACE,8BAA8B;EAC9B,uCAAuC;EACvC,yBAAyB;EACzB,sCAAsC;EACtC,sBAAsB;AACxB;AACA;EACE,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,qBAAqB;EACrB,wCAAwC;AAC1C;AACA;EACE,sBAAsB;AACxB;AACA;EACE,0BAA0B;EAC1B,8BAA8B;EAC9B,iBAAiB;EACjB,sCAAsC;AACxC;AACA;EACE,YAAY;EACZ,2CAA2C;EAC3C,6CAA6C;EAC7C,+BAA+B;EAC/B,qCAAqC;AACvC;AACA;EACE,UAAU;EACV,eAAe;AACjB;AACA,2EAA2E;AAC3E;EACE,eAAe;EACf,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;AACA;EACE,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,qBAAqB;AACvB;;AAEA;8CAC8C;AAC9C;EACE,yCAAyC;EACzC,4CAA4C;EAC5C,iDAAiD;AACnD;AACA;EACE,aAAa;EACb,UAAU;AACZ;;AAEA;EACE;IACE,0DAA0D;IAC1D,mBAAmB;EACrB;EACA;IACE,gBAAgB;IAChB,SAAS;EACX;AACF;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,wCAAwC;AAC1C;AACA;EACE,sBAAsB;AACxB;;AAEA,0EAA0E;AAC1E;;EAEE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,sCAAsC;AACxC;AACA;;;EAGE,WAAW;EACX,kBAAkB;EAClB,oBAAoB;EACpB,2CAA2C;EAC3C,mBAAmB;EACnB,2CAA2C;EAC3C,WAAW;EACX,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB;mCACiC;AACnC;AACA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,yDAAiP;EACjP,4BAA4B;EAC5B,sCAAsC;EACtC,0BAA0B;AAC5B;AACA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;AACA;;EAEE,gCAAgC;AAClC;AACA;;;EAGE,sCAAsC;AACxC;AACA;;;EAGE,aAAa;EACb,WAAW;EACX,6BAA6B;EAC7B,2CAA2C;EAC3C,6CAA6C;AAC/C;AACA;;EAEE,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,yDAAiP;AACnP;AACA;;EAEE,8CAA8C;AAChD;AACA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;AAChB;AACA,4CAA4C;AAC5C;EACE,6BAA6B;EAC7B,6CAA6C;EAC7C,iBAAiB;AACnB;AACA;EACE,6BAA6B;EAC7B,6BAA6B;EAC7B,sCAAsC;AACxC;AACA;EACE,iCAAiC;EACjC,6BAA6B;AAC/B;AACA;EACE,sCAAsC;EACtC,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,gCAAgC;EAChC,oBAAoB;EACpB,+BAA+B;EAC/B,wEAAwE;EACxE,kCAAkC;EAClC,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,6FAA6F;EAC7F,wGAAwG;AAC1G;AACA;EACE,2BAA2B;EAC3B,wBAAwB;EACxB,4FAA4F;AAC9F;AACA;EACE,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,sCAAsC;EACtC,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,wCAAwC;EACxC,kBAAkB;EAClB,kCAAkC;EAClC,WAAW;EACX,6BAA6B;EAC7B,gBAAgB;EAChB,iDAAiD;AACnD;AACA;EACE,kCAAkC;AACpC;AACA,+EAA+E;AAC/E;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,SAAS;EACT,aAAa;EACb,0CAA0C;EAC1C,mBAAmB;EACnB,sCAAsC;EACtC,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,WAAW;AACb;AACA;;EAEE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,SAAW;EACX,YAAY;AACd","sourcesContent":[".section h2 {\n  color: #fff;\n}\n.layout {\n  display: grid;\n  gap: var(--space-7);\n  grid-template-columns: minmax(0, 1fr);\n  align-items: start;\n}\n.intro :global(header) {\n  margin-bottom: var(--space-6);\n}\n.points {\n  margin: 0 0 var(--space-6);\n  padding: 0;\n  list-style: none;\n  display: grid;\n  gap: var(--space-3);\n}\n.points li {\n  position: relative;\n  padding-left: 1.75rem;\n  line-height: 1.5;\n}\n.points li::before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  top: 0.65em;\n  width: 0.9rem;\n  height: 2px;\n  background: var(--kur-gold);\n}\n.direct {\n  margin: 0;\n  display: flex;\n  flex-wrap: wrap;\n  gap: var(--space-4) var(--space-7);\n  padding-top: var(--space-5);\n  border-top: 1px solid var(--color-border-on-dark);\n}\n.direct dt {\n  font-size: var(--text-eyebrow);\n  letter-spacing: var(--tracking-eyebrow);\n  text-transform: uppercase;\n  color: var(--color-text-muted-on-dark);\n  margin-bottom: 0.25rem;\n}\n.direct dd {\n  margin: 0;\n  font-size: 1.15rem;\n}\n.direct a {\n  color: #fff;\n  text-decoration: none;\n  border-bottom: 1px solid var(--kur-gold);\n}\n.direct a:hover {\n  color: var(--kur-gold);\n}\n.note {\n  margin: var(--space-5) 0 0;\n  font-size: var(--text-caption);\n  line-height: 1.55;\n  color: var(--color-text-muted-on-dark);\n}\n.form {\n  min-width: 0;\n  padding: clamp(1.25rem, 1rem + 2vw, 2.5rem);\n  border: 1px solid var(--color-border-on-dark);\n  border-radius: var(--radius-lg);\n  background: rgba(255, 255, 255, 0.03);\n}\n.form :global(.container) {\n  padding: 0;\n  max-width: none;\n}\n/* forms written for older layouts set their own narrow width and padding */\n.form form {\n  max-width: none;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 1.1rem;\n}\n.form > div {\n  padding-top: 0;\n  padding-bottom: 0;\n}\n.direct dd {\n  white-space: pre-line;\n}\n\n/* Locations map under the form. The map component sizes itself for a full\n   page, so its outer box is tightened here. */\n.map {\n  margin-top: clamp(3rem, 2rem + 3vw, 5rem);\n  padding-top: clamp(2rem, 1.5rem + 2vw, 3rem);\n  border-top: 1px solid var(--color-border-on-dark);\n}\n.map > div {\n  min-height: 0;\n  padding: 0;\n}\n\n@media (min-width: 992px) {\n  .layout {\n    grid-template-columns: minmax(0, 0.85fr) minmax(0, 1.15fr);\n    gap: var(--space-8);\n  }\n  .intro {\n    position: sticky;\n    top: 9rem;\n  }\n}\n\n.note a {\n  color: #fff;\n  text-decoration: none;\n  border-bottom: 1px solid var(--kur-gold);\n}\n.note a:hover {\n  color: var(--kur-gold);\n}\n\n/* ---- Form fields: one dark, themed style for every audience form ---- */\n.form :global(.form-label),\n.form label {\n  margin-bottom: 0.4rem;\n  font-size: 0.85rem;\n  font-weight: 500;\n  letter-spacing: 0.01em;\n  color: var(--color-text-muted-on-dark);\n}\n.form :global(.form-control),\n.form :global(.form-select),\n.form textarea {\n  width: 100%;\n  min-height: 3.1rem;\n  padding: 0.8rem 1rem;\n  border: 1px solid rgba(255, 255, 255, 0.14);\n  border-radius: 10px;\n  background-color: rgba(255, 255, 255, 0.04);\n  color: #fff;\n  font-family: var(--font-sans);\n  font-size: 1rem;\n  box-shadow: none;\n  transition: border-color var(--dur-fast) ease, background-color var(--dur-fast) ease,\n    box-shadow var(--dur-fast) ease;\n}\n.form textarea {\n  min-height: 8rem;\n  resize: vertical;\n}\n.form :global(.form-select) {\n  padding-right: 2.75rem;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23ffd700' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/%3e%3c/svg%3e\");\n  background-repeat: no-repeat;\n  background-position: right 1rem center;\n  background-size: 14px 10px;\n}\n.form :global(.form-select) option {\n  color: var(--color-ink);\n  background: #fff;\n}\n.form :global(.form-control)::placeholder,\n.form textarea::placeholder {\n  color: rgba(255, 255, 255, 0.38);\n}\n.form :global(.form-control):hover,\n.form :global(.form-select):hover,\n.form textarea:hover {\n  border-color: rgba(255, 255, 255, 0.3);\n}\n.form :global(.form-control):focus,\n.form :global(.form-select):focus,\n.form textarea:focus {\n  outline: none;\n  color: #fff;\n  border-color: var(--kur-gold);\n  background-color: rgba(255, 255, 255, 0.07);\n  box-shadow: 0 0 0 3px rgba(255, 215, 0, 0.18);\n}\n.form :global(.form-control.is-invalid),\n.form :global(.form-select.is-invalid) {\n  border-color: #ff8a80;\n  background-image: none;\n}\n.form :global(.form-select.is-invalid) {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23ff8a80' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/%3e%3c/svg%3e\");\n}\n.form :global(.form-control.is-invalid):focus,\n.form :global(.form-select.is-invalid):focus {\n  box-shadow: 0 0 0 3px rgba(255, 138, 128, 0.2);\n}\n.form :global(.invalid-feedback) {\n  margin-top: 0.35rem;\n  font-size: 0.8rem;\n  color: #ff8a80;\n}\n/* keep browser autofill on the dark field */\n.form :global(.form-control):-webkit-autofill {\n  -webkit-text-fill-color: #fff;\n  -webkit-box-shadow: 0 0 0 100px #2a2f36 inset;\n  caret-color: #fff;\n}\n.form :global(.form-check-input) {\n  accent-color: var(--kur-gold);\n  background-color: transparent;\n  border-color: rgba(255, 255, 255, 0.4);\n}\n.form :global(.form-check-input:checked) {\n  background-color: var(--kur-gold);\n  border-color: var(--kur-gold);\n}\n.form :global(.form-check-label) {\n  color: var(--color-text-muted-on-dark);\n  line-height: 1.5;\n}\n.form button[type=\"submit\"] {\n  width: 100% !important;\n  min-height: 3.25rem;\n  padding: 0.85rem 2rem !important;\n  border: 0 !important;\n  border-radius: 999px !important;\n  background: linear-gradient(180deg, #ffe23a, var(--kur-gold)) !important;\n  color: var(--color-ink) !important;\n  font-family: var(--font-sans);\n  font-size: 1rem;\n  font-weight: 600;\n  letter-spacing: 0.02em;\n  box-shadow: 0 10px 30px -10px rgba(255, 215, 0, 0.55), inset 0 1px 0 rgba(255, 255, 255, 0.5);\n  transition: transform var(--dur-fast) ease, box-shadow var(--dur-fast) ease, filter var(--dur-fast) ease;\n}\n.form button[type=\"submit\"]:hover:not(:disabled) {\n  transform: translateY(-2px);\n  filter: brightness(1.04);\n  box-shadow: 0 16px 36px -12px rgba(255, 215, 0, 0.7), inset 0 1px 0 rgba(255, 255, 255, 0.5);\n}\n.form button[type=\"submit\"]:disabled {\n  opacity: 0.6;\n  cursor: progress;\n}\n.form :global(.form-control[type=\"file\"]) {\n  padding: 0.45rem;\n  line-height: 2;\n  color: var(--color-text-muted-on-dark);\n  cursor: pointer;\n}\n.form :global(.form-control[type=\"file\"])::file-selector-button {\n  margin: 0 1rem 0 0;\n  padding: 0.45rem 1rem;\n  border: 1px solid rgba(255, 215, 0, 0.6);\n  border-radius: 6px;\n  background: rgba(255, 215, 0, 0.1);\n  color: #fff;\n  font-family: var(--font-sans);\n  font-weight: 500;\n  transition: background-color var(--dur-fast) ease;\n}\n.form :global(.form-control[type=\"file\"]):hover::file-selector-button {\n  background: rgba(255, 215, 0, 0.2);\n}\n/* consent checkbox: left-aligned, readable, box lined up with the first line */\n.form :global(.form-check) {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.75rem;\n  margin: 0;\n  padding: 1rem;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 10px;\n  background: rgba(255, 255, 255, 0.025);\n  text-align: left;\n}\n.form :global(.form-check-input) {\n  flex: none;\n  width: 1.15rem;\n  height: 1.15rem;\n  margin: 0.15rem 0 0;\n  float: none;\n}\n.form :global(.form-check-label),\n.form :global(.form-check-label) * {\n  font-size: 0.85rem;\n  text-align: left;\n}\n.form :global(.form-check) :global(.invalid-feedback) {\n  flex-basis: 100%;\n}\n.form :global(.form-check) {\n  flex-wrap: wrap;\n}\n.form :global(.form-check-label) {\n  flex: 1 1 0;\n  min-width: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"section": `contactBlock_section__82tMN`,
	"layout": `contactBlock_layout__F-qZZ`,
	"intro": `contactBlock_intro__XWtOl`,
	"points": `contactBlock_points__csQOX`,
	"direct": `contactBlock_direct__S-sQs`,
	"note": `contactBlock_note__xKt3Q`,
	"form": `contactBlock_form__b3E8E`,
	"map": `contactBlock_map__SICFF`
};
export default ___CSS_LOADER_EXPORT___;
